export default __webpack_public_path__ + "img/5452b3e43249f65037c68c68f3913efa.png";